import * as ko from "knockout";
import {Estimate} from "./estimate";
import {Costbook} from "./costbook";
import {BufferItem} from "../buffer/bufferItem";
import {ActivePanel} from "./activePanel";
import {SidebarItemType} from "./sidebarItemType";
import {SearchbarItemType} from "./searchBarItemType";
import {Bookmark} from "./bookmark";

export class ApplicationState {

    mainMenuVisible = ko.observable(false);

    activePanel = ko.observable<ActivePanel | undefined>(undefined);
    
    activeSidebarItem = ko.observable<SidebarItemType| undefined>(undefined);
    
    activeSidebarSelectedItemIndex = ko.observable<number|undefined>();
    sidebarSearchTerm = ko.observable<string>();
    activeSearchbarItem = ko.observable<SearchbarItemType>(SearchbarItemType.All);

    activeSearchSelectedItemIndex = ko.observable<number|undefined>();

    estimate = ko.observable<Estimate|undefined>();
    estimateLoading = ko.observable<boolean>(false);
    
    canCreateEstimateSubtotalRow = ko.observable<boolean>(false);

    costbook = ko.observable<Costbook | undefined>(undefined);

    costbookLoading = ko.observable<boolean>(false);

    costbooks = ko.observableArray<Costbook>();
    
    canUndo = ko.observable<boolean>(false);
    canRedo = ko.observable<boolean>(false);

    buffer = ko.observableArray<BufferItem>();

    bookmarks = ko.observableArray<Bookmark>();

    history = ko.observable<Date>();
    customerInfo = ko.observable<Date>();
    companyInfo = ko.observable<Date>();
    taxRates = ko.observable<Date>();
    markups = ko.observable<Date>();
    percentages = ko.observable<Date>();
    areaCostsModifications = ko.observable<Date>();

    estimateGridDoubleSpaceLines = ko.observable<boolean>(false);
    estimateGridShowUnitCosts = ko.observable<boolean>(false);
    estimateGridHideComponentCosts = ko.observable<boolean>(false);
}


// WEBPACK FOOTER //
// ./ClientApp/services/state/applicationState.ts